module.exports = __webpack_public_path__ + "static/media/portfolio1 (55).154ce748.jpeg";